var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Carril")]),_c('v-btn-toggle',{attrs:{"color":"success","group":""}},_vm._l((_vm.itemsPosition),function(item){return _c('v-btn',{attrs:{"value":item.ChpID},on:{"click":function($event){return _vm.select(item)}}},[_vm._v(" "+_vm._s(item.ChpPosition)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }